/* eslint-disable no-case-declarations */
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { MARKETSHARE_CLASSES } from '../../utils/constants';
import { flattenObject } from '../../utils/objectHelpers';
const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  paginatedElements: 0,
  initialData: [],
  marker_data: [],
  startDate: '',
  endDate: '',
  showDbwPins: {
    'MPE DBW': true,
    'NON-MPE DBW': true,
    DBW: true,
    TARGET: true
  },
  dbWDivisions: [],
  division: 'ALL',
  dbwSyncStatus: '',
  dbwDetailsLoading: false,
  dbwDetailsError: '',
  dbwDetails: {},
  kpis: {
    data: [],
    initialData: [],
    loading: false,
    errorMessage: '',
    chartData: [],
    divisions: [],
    selectedDivision: 'ALL',
    searchTerm: '',
    selectedClasses: MARKETSHARE_CLASSES
  }
};
const dbwVsTargetReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.DBW_VS_TARGET_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_LIST_SUCCESS:
      const divisions = [...new Set(action.payload.data.map(item => item.division))];
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        initialData: [...action.payload.data],
        marker_data: [...action.payload.data],
        dbWDivisions: divisions,
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_SEARCH_CHANGE:
      return {
        ...state,
        searchTerm: action.payload.value,
      };

    case REDUX_ACTIONS.DBW_VS_TARGET_FILTER:
      const activePinsForFilter = Object.keys(state.showDbwPins).filter(pin => state.showDbwPins[pin]);

      const checkMatch = (item, searchTerm) => {
        const rigNameMatch = item?.RigName_Number?.toUpperCase().includes(searchTerm.toUpperCase());
        const rigSpecsMatch = item?.rigSpecs && Object.values(flattenObject(item?.rigSpecs)).some(val =>
          val && val.toString().toUpperCase().includes(searchTerm.toUpperCase())
        );

        return rigNameMatch || rigSpecsMatch;
      };

      const filteredData = state.initialData.filter(item => {
        const classMatch = activePinsForFilter.includes(item?.class);
        const searchMatch = checkMatch(item, state.searchTerm);

        return classMatch && searchMatch;
      });

      return {
        ...state,
        data: filteredData.length > 0 ? filteredData : [],
        marker_data: filteredData.length > 0 ? filteredData : [],
      };

    case REDUX_ACTIONS.DBW_VS_TARGET_SET_DATE:
      return {
        ...state,
        startDate: action.payload.selectedStartDateTime,
        endDate: action.payload.selectedEndDateTime
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_MARKER_DATA:
      const activePins = Object.keys(action.payload).filter(pin => action.payload[pin]);
      const selectedDivision = state.division;

      return {
        ...state,
        showDbwPins: { ...action.payload },
        marker_data: state.initialData.filter(item =>
          item?.class &&
          activePins.includes(item.class) &&
          (selectedDivision === 'ALL' || item?.division === selectedDivision)
        ),
        data: state.initialData.filter(item =>
          item?.class &&
          activePins.includes(item.class) &&
          (selectedDivision === 'ALL' || item?.division === selectedDivision)
        ),
      };

    case REDUX_ACTIONS.DBW_VS_TARGET_DIVISION_DATA:
      const activeDivisionPins = Object.keys(state.showDbwPins).filter(pin => state.showDbwPins[pin]);
      return {
        ...state,
        division: action.payload,
        marker_data: state.initialData.filter(item =>
          (action.payload === 'ALL' || item?.division === action.payload) &&
          activeDivisionPins.includes(item.class)
        ),
        data: state.initialData.filter(item =>
          (action.payload === 'ALL' || item?.division === action.payload) &&
          activeDivisionPins.includes(item.class)
        ),
      };

    case REDUX_ACTIONS.DBW_VS_TARGET_DIVISION_RESET:
      return {
        ...state,
        division: 'ALL',
      };

    case REDUX_ACTIONS.DBW_SYNC_LOADING:
      return {
        ...state,
        dbwSyncStatus: action.payload,
        loading: false,
      };

    case REDUX_ACTIONS.ENVERUS_WELL_DETAILS_LOADING:
      return {
        ...state,
        dbwDetails: {},
        dbwDetailsLoading: true,
        dbwDetailsError: '',
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_FETCH_DETAILS_SUCCESS:
      return {
        ...state,
        dbwDetails: action.payload,
        dbwDetailsLoading: false,
        dbwDetailsError: '',
      };
    case REDUX_ACTIONS.DBW_VS_TARGET_FETCH_DETAILS_ERROR:
      return {
        ...state,
        dbwDetails: {},
        dbwDetailsLoading: false,
        dbwDetailsError: action.payload.message,
      };

    case REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_LOADING:
      return {
        ...state,
        kpis: {
          ...state.kpis,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_SUCCESS:
      return {
        ...state,
        kpis: {
          ...state.kpis,
          loading: false,
          executeSearch: false,
          initialData: [...action.payload.data],
          data: [...action.payload.data],
          chartData: [...action.payload.chartData],
          divisions: [...action.payload.divisions],
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_ERROR:
      return {
        ...state,
        kpis: {
          ...state.kpis,
          loading: false,
          executeSearch: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.MARKETSHARE_KPIS_SET_DIVISION:
      return {
        ...state,
        kpis: {
          ...state.kpis,
          loading: false,
          data: [...action.payload.data],
          chartData: [...action.payload.chartData],
          selectedDivision: action.payload.selectedDivision,
          selectedClasses: action.payload.selectedClasses,
          searchTerm: action.payload.searchTerm,
        }
      };
    case REDUX_ACTIONS.MARKETSHARE_KPIS_LIST_SEARCH_CHANGE:
      return {
        ...state,
        kpis: {
          ...state.kpis,
          searchTerm: action.payload,
        }
      };
    default:
      return state;
  }
};
export default dbwVsTargetReducer;
